import React, { PropTypes } from "react";
import ReactGA from "react-ga";
import { Provider } from "react-redux";
import { Router } from "react-router";
import { anchorate } from "anchorate";
import { getRoutes } from "./routes";
import scroller from "./scroller";

const onRouteUpdate = () => {
  // eslint-disable-next-line new-cap
  window.Intercom("update");
  ReactGA.pageview(window.location.pathname + window.location.search);
  anchorate({
    scroller: function (element) {
      if (!element) return false;
      scroller.scrollVerticalToElementById(element.id, 10);
      return true;
    },
  });
};

export default function Root({ history, store }) {
  return (
    <Provider store={store}>
      <Router
        history={history}
        routes={getRoutes(store.getState)}
        onUpdate={onRouteUpdate}
      />
    </Provider>
  );
}

Root.propTypes = {
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/views/root.js
 **/